import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformaceDetailWidget from "b2b/components/provozni-informace-detail-widget/ProvozniInformaceDetailWidget";
import Detail from "b2b/components/provozni-informace-detail-widget/Detail";
import DetailPlaceholder from "b2b/components/provozni-informace-detail-widget/DetailPlaceholder";
import HeaderActions from "b2b/components/provozni-informace-detail-widget/HeaderActions";
import Title from "b2b/components/provozni-informace-detail-widget/Title";
import TitleDescription from "b2b/components/provozni-informace-detail-widget/TitleDescription";

export function ProvozniInformaceDetailWidgetExample() {
  const provozniInformace = require("b2b-devel/provozni-informace/informace.json");

  return (
    <>
      <PageHeading>ProvozniInformaceDetailWidget</PageHeading>
      <div data-testid="ProvozniInformaceDetailWidget">
        <ProvozniInformaceDetailWidget id={1} />
      </div>

      <div className="b2b-ProvozniInformaceDetailWidget">
        <PageHeading>Detail</PageHeading>
        <div data-testid="Detail">
          <Detail provozniInformace={provozniInformace} />
        </div>
        <PageHeading>DetailPlaceholder</PageHeading>
        <div data-testid="DetailPlaceholder">
          <DetailPlaceholder />
        </div>

        <PageHeading>HeaderActions</PageHeading>
        <div data-testid="HeaderActions">
          <HeaderActions provozniInformace={provozniInformace} />
        </div>
        <div data-testid="HeaderActions-noInformation">
          <HeaderActions />
        </div>

        <PageHeading>Title</PageHeading>
        <div data-testid="Title">
          <Title provozniInformace={provozniInformace} />
        </div>
        <div data-testid="Title-loading">
          <Title loading />
        </div>

        <PageHeading>TitleDescription</PageHeading>
        <div data-testid="TitleDescription">
          <TitleDescription provozniInformace={provozniInformace} />
        </div>
        <div data-testid="TitleDescription-loading">
          <TitleDescription loading />
        </div>
      </div>
    </>
  );
}

ProvozniInformaceDetailWidgetExample.propTypes = {};

export default React.memo(ProvozniInformaceDetailWidgetExample);
